import type { GuideTopic } from "../guide/topics";

/**
 * Captain Bram's Guide topics for the economy (FINISH_PLAN WP5; registered through the feature registry, replayable
 * from ⚙ → Guide): the Shop, the Market and the upgrade queue. Bram's voice, each line at most two sentences and
 * 22 words (topics.ts). They open with the castle topics, once the first level is cleared (the hub unlock).
 */
const CASTLE_FROM = 2;

export const SHOP_TOPIC: GuideTopic = {
  id: "shop", group: "castle", label: "Shop & gems", art: { icon: "shop" }, fromLevel: CASTLE_FROM, steps: [],
  lines: [
    "The **Shop** tab has a tab per shop: the **Merchant**, **Supplies** for speed-ups and gold, then Event, VIP, Trophies and Skins.",
    "**Gems** hire builders and buy speed-ups. Tap them up top to open the **Store**.",
    "Gems come from stars, bosses, the weekly chest and check-ins. Spend them wisely, Commander.",
  ],
};

export const MARKET_TOPIC: GuideTopic = {
  id: "market", group: "castle", label: "Market", art: { icon: "coin" }, fromLevel: CASTLE_FROM, steps: [],
  lines: [
    "Spare **Rare** gear or better? The **Trading Post** pays **Marks** for it, more than salvage ever would!",
    "Marks buy gear from the **Mystery Merchant**, whose stock changes every day. Find him in **Shop → Merchant**.",
    "The **Black Market** offers one Legendary or Mythic piece a day, for gems, with no timers. It can't be resold for Marks.",
  ],
};

export const QUEUE_TOPIC: GuideTopic = {
  id: "queue", group: "castle", label: "Upgrade queue", art: { icon: "builder" }, fromLevel: CASTLE_FROM, steps: [],
  lines: [
    "Builders all busy? Tap **QUEUE** and that upgrade starts the moment one is free.",
    "Each builder holds one queued job. You pay now, and cancelling it gives everything back.",
    "The queue keeps working while you're away, so line one up before you log off!",
    "In a hurry? **Finish now** ends a running upgrade for gems, priced by the hours left; speed-ups do it cheaper.",
  ],
};
